import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export const EngineeringNav = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navLinks = [
    { path: '/engineering', label: 'Home' },
    { path: '/engineering/about', label: 'About' },
    { path: '/engineering/services', label: 'Services' },
    { path: '/engineering/portfolio', label: 'Portfolio' },
    { path: '/engineering/quote', label: 'Get a Quote' },
    { path: '/engineering/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-black/95 backdrop-blur-sm border-b border-[#333333]" data-testid="engineering-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="engineering-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_cad-craft-studio-1/artifacts/jhyl88a1_Picture1.png" 
              alt="BJe Logo" 
              className="h-14 w-auto object-contain"
              style={{ filter: 'brightness(0) saturate(100%) invert(31%) sepia(93%) saturate(2032%) hue-rotate(351deg) brightness(101%) contrast(95%)' }}
            />
            <span className="font-nunito font-bold text-xl text-white">BJ Engineering</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-full font-nunito text-sm transition-colors ${
                  isActive(link.path)
                    ? 'bg-[#F54021] text-white font-semibold'
                    : 'text-gray-300 hover:text-white hover:bg-[#1a1a1a]'
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Back to Main */}
          <Link 
            to="/" 
            className="hidden md:block text-sm text-gray-400 hover:text-[#F54021] font-nunito transition-colors"
            data-testid="back-to-main"
          >
            ← Back to Main
          </Link>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#333333]">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 font-nunito text-sm ${
                  isActive(link.path)
                    ? 'bg-[#F54021]/20 text-[#F54021] font-semibold'
                    : 'text-gray-300'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link 
              to="/" 
              className="block px-4 py-3 text-sm text-gray-400 border-t border-[#333333] mt-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              ← Back to Main
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
